<template>
  <el-dialog :visible="dailogShow" title="好友申请详细信息" :before-close="handleCloseDailog" @open="handleOpenDailog">

    <el-descriptions :column="1" border>
      <el-descriptions-item label="姓名">{{ noticeInfo.UserName }}</el-descriptions-item>
      <el-descriptions-item label="单位">{{ noticeInfo.DanWeiMingCheng }}</el-descriptions-item>
      <el-descriptions-item label="部门">{{ noticeInfo.BuMen }}</el-descriptions-item>
      <el-descriptions-item label="科室">{{ noticeInfo.KeShi }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{ noticeInfo.ApplyDT }}</el-descriptions-item>
      <el-descriptions-item label="留言">{{ noticeInfo.ApplyMessage }}</el-descriptions-item>
    </el-descriptions>

    <div class="dialog-footer">
      <el-button v-if="!btnAddEnable" type="primary" @click="handleAgreedFriend">同 意</el-button>
      <el-button v-else type="primary" disabled>已添加</el-button>
      <el-button @click="handleCloseDailog">取 消</el-button>

    </div>

  </el-dialog>
</template>
<script>
import pathReq from '@/api/pathlist'
export default {
  data() {
    return {
      dailogShow: false,
      noticeId: null,
      noticeInfo: {},
      btnAddEnable: false
    }
  },
  methods: {
    show(id, detailJson) {
      const that = this
      this.noticeId = id
      if (detailJson) {
        this.noticeInfo = JSON.parse(detailJson)
      }
      const path = '/api/services/app/Contact/CheckContactIsFriend'
      pathReq.postForm(path, { id: this.noticeInfo.ContactKey }).then(r => {
        that.btnAddEnable = r.data.result
      })

      this.dailogShow = true
    },
    handleOpenDailog() {

    },
    handleCloseDailog() {
      this.dailogShow = false
    },
    /** 同意 */
    handleAgreedFriend() {
      const path = '/api/services/app/Contact/AgreedFriend'
      pathReq.postForm(path, { id: this.noticeInfo.ContactKey })
        .then(res => {
          if (res.status === 200) {
            if (res.data.success) {
              this.$message.success('添加好友成功！')
            } else {
              this.$message.error('添加好友失败！')
            }
          }
          this.dailogShow = false
        })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
